import { apiGet, apiPost } from "../shared/apiClient";
import { listQueries } from '../queries/queriesV1Model';

// Single GET, parameterized differently by each caller: the board's own
// date/agent/search fetch (QuerysetV4.js), and a plain {customer_id} lookup
// reused by the chat drawer's "View Queries" tab and the customer profile
// drawer's Queries tab. One generic query-string builder covers all of it.
export function fetchQueries(params = {}) {
  return listQueries(params);
}

// One board-shaped card by query_pk, for queries that aren't on the loaded
// board (older dates, other filters). Null when the server returns none.
export function fetchQueryCard(queryPk) {
  return fetchQueries({ id: queryPk }).then(rows => rows.find(row => String(row.id) === String(queryPk)) || null);
}

// Callers branch on res.data.success/res.data.message themselves (e.g. to
// throw a specific error), so the raw payload is returned as-is.
export function createQuery(payload) {
  return apiPost("/queryset_v2/create", payload).then(res => res.data);
}

export function updateDraft(payload) {
  return apiPost("/queryset_v2/update_draft", payload).then(res => res.data);
}

export function updateUrgency(taskId, urgency) {
  return apiPost("/query_workflow/update_urgency", { task_id: taskId, urgency }).then(res => res.data);
}

// Overwrites created_at with now; the original value is preserved
// server-side in the task's timeline, not here. See
// docs/superpowers/specs/2026-07-27-bring-query-to-today-design.md.
export function bringQueryToToday(taskId) {
  return apiPost("/queryset_v2/bring_to_today", { task_id: taskId }).then(res => res.data);
}

export function fetchFollowupsDue() {
  return apiGet("/query_workflow/followups_due")
    .then(res => (res.data?.success ? (res.data.data || []) : []))
    .catch(() => []);
}

// Pending quote-approval requests, keyed by query_pk for O(1) badge lookup
// on the board — mirrors QuerysetV4.js's own map-building right after fetch.
export function fetchActiveApprovals() {
  return apiGet("/queries/approvals/active")
    .then(res => {
      const map = {};
      (res.data?.data ?? []).forEach(a => { map[a.query_pk] = a; });
      return map;
    })
    .catch(() => ({}));
}

export function approveApproval(approvalId, payload) {
  const { userId, ...body } = payload;
  return apiPost(`/queries/approvals/${approvalId}/approve`, body).then(res => res.data);
}

export function rejectApproval(approvalId, payload) {
  const { userId, ...body } = payload;
  return apiPost(`/queries/approvals/${approvalId}/reject`, body).then(res => res.data);
}
